import { approveMarketForNFT, batchBuy, batchDelist, batchList, batchMint, batchUpdatePrice, ethToWei, setWallet, setRunnerAddress, withdraw, } from '../../chains/evm/api';
import { WEB3_ADDRESS } from '../../wallet';
export async function callEVMContract(deps, action, metadata, fn) {
    if (WEB3_ADDRESS[deps.activeChain]?.chainId && deps.evmSigner) {
        setWallet(deps.activeChain, deps.evmSigner);
        const txId = await fn();
        setRunnerAddress(deps.activeChain, deps.evmSigner?.address);
        deps.addTransaction(deps.activeChain, txId.hash, action, metadata);
        if (Array.isArray(txId)) {
            return txId.map((txInfo) => deps.txIdToLink(typeof txInfo === 'string' ? txInfo : txInfo.hash));
        }
        return deps.txIdToLink(typeof txId === 'string' ? txId : txId.hash);
    }
    throw Error('Please connect wallet to execute transaction!!!');
}
export async function mintEvmNFTs(deps, nfts, uris) {
    return callEVMContract(deps, 'Mint', nfts, async () => {
        const royaltyBps = nfts[0]?.royaltyBps ?? 500;
        if (!deps.evmSigner?.address) {
            throw Error('Please connect wallet to execute transaction!!!');
        }
        return batchMint(deps.activeChain, deps.evmSigner.address, uris, royaltyBps);
    });
}
export async function buyEvmNFTs(deps, nfts) {
    return callEVMContract(deps, 'Buy', nfts, async () => {
        const version = nfts[0]?.version ?? 0;
        return batchBuy(deps.activeChain, version, nfts.map((info) => info.tokenId), nfts
            .map((nft) => nft.weiPrice)
            .reduce((sum, price) => sum + BigInt(price ?? 0), BigInt(0)));
    });
}
export async function withdrawEvmProceeds(deps) {
    return callEVMContract(deps, 'Withdraw Proceeds', null, async () => {
        return withdraw(deps.activeChain);
    });
}
export async function listEvmNFTs(deps, nfts) {
    return callEVMContract(deps, 'List', nfts, async () => {
        const version = nfts[0]?.version ?? 0;
        if (!deps.activeState.isApprovedMarket?.[version]) {
            deps.toast.info('You should approve your wallet to transfer nfts anytime');
            await approveMarketForNFT(deps.activeChain, version);
        }
        return batchList(deps.activeChain, version, nfts.map((info) => [info.tokenId, ethToWei(info.price)]));
    });
}
export async function delistEvmNFTs(deps, nfts) {
    return callEVMContract(deps, 'Delist', nfts, async () => {
        return batchDelist(deps.activeChain, nfts[0]?.version ?? 0, nfts.map((nft) => nft.tokenId));
    });
}
export async function updateEvmNFTPrices(deps, nfts) {
    return callEVMContract(deps, 'Update Price', nfts, async () => {
        return batchUpdatePrice(deps.activeChain, nfts[0]?.version ?? 0, nfts.map((info) => [info.tokenId, ethToWei(info.price)]));
    });
}
